export default __webpack_public_path__ + "static/media/white-cam-card.37347ad8.png";